import { Flex, Heading } from '@chakra-ui/react';

import { Alert } from '~/components/alert';
import { Filters } from '~/features/catalog/models/filter';
import { useI18n } from '~/hooks/use-i18n';

import { getCatalogSearchTitle } from '../utils/get-catalog-search-title';

import { CatalogInlineSearch } from './catalog-inline-search';
import { CatalogSearchActiveFilters } from './catalog-search-active-filters';

export function CatalogSearchHeader({
  searchValue,
  selectedFilters,
}: {
  searchValue?: string;
  selectedFilters: Filters;
}) {
  const { t, isTranslated } = useI18n();
  const hasSearch = Boolean(searchValue?.trim());

  return (
    <Flex as='header' flexDirection='column' gap='16px'>
      <Heading
        as='h2'
        color='grey.900'
        fontSize={{ base: '1.25rem', md: '1.75rem' }}
        fontWeight='600'
        letterSpacing={{ base: '-0.6px', md: '-0.84px' }}
        lineHeight={{ base: '24px', md: '34px' }}
        textTransform={hasSearch ? undefined : 'capitalize'}
      >
        {getCatalogSearchTitle({ searchValue, selectedFilters, t })}
      </Heading>
      {isTranslated && hasSearch && (
        <Alert fontSize='sm' status='info'>
          {t('catalog.translatedResultsAlert')}
        </Alert>
      )}
      <CatalogInlineSearch />
      <CatalogSearchActiveFilters selectedFilters={selectedFilters} />
    </Flex>
  );
}
